import { render, staticRenderFns } from "./CoreCategories.vue?vue&type=template&id=69e5ad66"
import script from "./CoreCategories.vue?vue&type=script&lang=js"
export * from "./CoreCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports